import { HomeContainer } from "components/UI/atoms";
import "./index.scss";

import { HomeCarousel, TopCategories } from "components/UI/organisms";

export const HomePromotions = () => (
  <HomeContainer>
    <div className="home-promotions">
      <div className="categories">
        <TopCategories />
      </div>
      <HomeCarousel />
    </div>
  </HomeContainer>
);
